module.exports = __webpack_public_path__ + "static/media/libro13.f431e448.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro13.jpeg
// module id = 361
// module chunks = 0